import { BirthTranslate } from './birthTranslate.model';

const birthTranslateEN: BirthTranslate = {
  tab: {
    title: 'Births',
    empty: 'No birth registered for this client',
    add: 'Add birth',
  },
  card: {
    expectedBirthDate: 'Expected birth date',
    birthDate: 'Born on',
    babyName: 'Baby name',
    deliveryMethod: 'Delivery method',
    location: 'Location',
    photographyWishes: 'Photography wishes',
    noExpectedBirthDate: 'No expected date',
    edit: 'Edit birth',
    delete: 'Delete birth',
    confirmDelete: 'Delete birth',
    confirmDeleteMessage: 'Are you sure you want to delete this birth?',
    cancelDelete: 'Cancel',
  },
  form: {
    titleCreate: 'New birth',
    titleEdit: 'Edit birth',
    expectedBirthDate: 'Expected birth date',
    birthDate: 'Actual birth date',
    babyName: 'Baby name',
    deliveryMethod: 'Delivery method',
    deliveryMethodNone: 'Not defined',
    location: 'Birth location',
    photographyWishes: 'Photography wishes',
    submit: 'Save',
    clear: 'Clear fields',
  },
  deliveryMethod: {
    NORMAL: 'Vaginal',
    CESAREAN_SCHEDULED: 'Scheduled c-section',
    CESAREAN_EMERGENCY: 'Emergency c-section',
    HOME: 'Home birth',
  },
  event: {
    field: 'Linked birth',
    none: 'None',
    optionWithBaby: '{{babyName}} — {{date}}',
    optionWithoutBaby: 'Birth — {{date}}',
  },
  errors: {
    expectedBirthDateInvalid: 'Invalid date',
    birthDateInvalid: 'Invalid date',
    babyNameTooLong: 'The baby name must be at most 100 characters long',
    photographyWishesTooLong:
      'The photography wishes must be at most 2000 characters long',
  },
  toast: {
    created: 'Birth created successfully',
    updated: 'Birth updated successfully',
    deleted: 'Birth deleted successfully',
    error: 'Could not save the birth',
  },
};

export default birthTranslateEN;
